<template>
    <div id="photo-sidebar-menu" class="sidebar-menu-container">
        <div class="lite-sidebar-main-label">
            Выберите дизайн
        </div>
<!--        <div class="sidebar-text-area">Выберите одну из плоскостей, чтобы применить текстуры или воспользуйтесь уже-->
<!--            готовыми дизайнерскими решениями.-->
<!--        </div>-->
        <DesignList @selectDesign='selectDesign'
                    @openDesign='openDesign'
                    :isLite="true"/>
    </div>
</template>

<script>
    import DesignList from "../SidebarComponents/DesignListSidebarMenu/DesignList";

    export default {
        name: "LiteSidebarDesignList",
        components: {DesignList},
        methods: {
            selectDesign(designID) {
                this.$router.replace({name: "liteDesignListSelected", params: {designID: designID}}).catch(err => {
                });
            },
            openDesign(designID) {
                this.$router.push({
                    name: "lightResultImages",
                    params: {designID: designID}
                }).catch(() => {
                });
            },
        },
        mounted() {
            if(!this.$store.state.route.params.designID){
                const designList = this.$store.getters['active/ALL_DESIGNS'];
                let designID = Object.keys(designList)[0];
                if(designID){
                    this.selectDesign(designID);
                }
            }
        },
    }
</script>

<style scoped>
    .lite-sidebar-main-label {
        margin: 20px 0;
        font-weight: bold;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: block;
        overflow: hidden;
        font-size: 18px;
        font-family: 'Red Ring', sans-serif;
        color: #292929;
    }

</style>
